module.exports = __webpack_public_path__ + "img/Corporate.fa0e28e8.svg";